import { createGenericDispatcher } from '../../action/action-dispatcher-factory';
import { recentAccountScoreGenerationLogStatusSelector } from '../account-score-generation-log-selectors';

import * as Api from '../../api/api';

export const loadRecentAccountScoreGenerationLog = () =>
  createGenericDispatcher<AccountScoreGenerationLog | null>({
    name: 'LOAD_RECENT_ACCOUNT_SCORE_GENERATION_LOG',
    loadFunction: () => Api.get('/account-score-generation-log/recent'),
    args: {},
    shouldExecuteSelector: (state: any) => recentAccountScoreGenerationLogStatusSelector(state),
  });
